// extracted by mini-css-extract-plugin
module.exports = {"table-container":"PendingOrders_table-container__EXCxV","table-wrapper":"PendingOrders_table-wrapper__3CPPt","table":"PendingOrders_table__2rOhJ"};